import React, { useState } from "react";
import { useInvoiceContext, useControlContext } from "../context";
import { Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";
import InputMask from "react-input-mask";
import ButtonNext from "./ButtonNext";
import { API_BASE_URL } from "../config";
import CardResume from "./CardResume";
import showError from "./ModalError";

const FormPhone = (props) => {
  const [showResumo, setShowResumo] = useState(false);

  const {
    customer,
    setCustomerPhone,
    setCustomerPhoneAlt,
    setAcceptWhats,
    setCustomerID,
  } = useInvoiceContext();
  const { setActiveFormPhone, isNewCustomer } = useControlContext();

  const [isLoading, setIsLoading] = useState(false);

  const { active, handleNext } = props;

  const validatePhone = (phone) => {
    const regex = /^[1-9]{2}[2-9][0-9]{3,4}[0-9]{4}$/;
    const phonec = phone.replace(/\D/g, "");
    return regex.test(phonec);
  };

  const showFormatedPhone = (phone) => {
    const regex = /^(\d{2})(\d{4,5})(\d{4})$/;
    const match = phone.match(regex);
    if (match) {
      const ddd = match[1];
      const firstSector = match[2];
      const secondSector = match[3];
      if (firstSector.length === 4) {
        return `(${ddd}) ${firstSector}-${secondSector}`;
      } else {
        return `(${ddd}) ${firstSector.slice(0, 5)}-${firstSector.slice(
          5,
        )}${secondSector}`;
      }
    } else {
      return phone;
    }
  };

  const dynamicMask = (value) => {
    if (value.length < 11) {
      return "(99) 9999-99999";
    } else {
      return "(99) 9 9999-9999";
    }
  };

  const next = () => {
    if (isNewCustomer && !customer.id) {
      console.log("registerNewCustomer");
      registerNewCustomer();
    } else {
      setShowResumo(true);
      handleNext();
    }
  };

  const edit = () => {
    setShowResumo(false);
    setActiveFormPhone(true);
  };

  const canNext = () => {
    if (validatePhone(customer.fone) || validatePhone(customer.fone_alt)) {
      return false;
    }
    return true;
  };

  const registerNewCustomer = async () => {
    setIsLoading(true);

    const response = await fetch(API_BASE_URL + `/customer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(customer),
    });
    const data = await response.json();
    if (data.id) {
      console.log(data);
      setIsLoading(false);
      setCustomerID(data.id);
      setShowResumo(true);
      handleNext();
    } else {
      console.error(data.message);
      setIsLoading(false);
      showError(data);
    }
  };

  return (
    <div className="position-relative">
      <Card hidden={!active || showResumo} border="primary mb-2">
        <Card.Body>
          <Card.Subtitle>
            <FontAwesomeIcon icon={faPhone} color="#0d6efd" /> Telefone de
            Contato
          </Card.Subtitle>
          <Form>
            <div className="form-group mb-2">
              <label>Telefone Celular</label>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Ex: (27) 9 8803-8225"
                value={customer.fone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                as={InputMask}
                mask={dynamicMask(customer.fone)}
                maskChar={""}
                isValid={
                  customer.fone.length > 3 &&
                  validatePhone(customer.fone)
                }
                isInvalid={
                  customer.fone.length > 3 &&
                  !validatePhone(customer.fone)
                }
              />
              
              <label>Telefone Comercial</label>
              <Form.Control
                size="sm"
                type="text"
                as={InputMask}
                value={customer.fone_alt}
                mask={dynamicMask(customer.fone_alt)}
                maskChar={""}
                placeholder="Ex: (27) 3222-0951"
                onChange={(e) => setCustomerPhoneAlt(e.target.value)}
                isValid={
                  customer.fone_alt.length > 3 && validatePhone(customer.fone_alt)
                }
                isInvalid={
                  customer.fone_alt.length > 3 && !validatePhone(customer.fone_alt)
                }
              />
              
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Aceito receber mensagens via WhatsApp"
                checked={customer.aceita_whats === "S" ? 1 : 0}
                onChange={() =>
                  setAcceptWhats(customer.aceita_whats === "S" ? "N" : "S")
                }
              />
            </div>
            <ButtonNext
              disabled={canNext()}
              className="float-end"
              onClick={next}
              text="Próximo"
              faicon={faArrowRight}
              isLoading={isLoading}
            />
          </Form>
        </Card.Body>
      </Card>
      <CardResume
        show={showResumo}
        handleEdit={edit}
        title="Telefone de Contato:"
        icon={faPhone}
      >
        {customer.fone ? showFormatedPhone(customer.fone) : null}
        {customer.fone  && customer.fone_alt ? <br /> : null}
        {customer.fone_alt ? showFormatedPhone(customer.fone_alt) : null}
      </CardResume>
    </div>
  );
};

export default FormPhone;
